export const logo = require('./WD-Icon.png')
export const unpin = require("./icons/icon-unpin.svg").default
export const pin = require("./icons/Icon-pin.svg").default
export const icons = {
  plusIcon: "Icon-plus.svg", carretDown: "Icon-caret-down.svg", filterIcon: <path
    d="M10 11L16 6V2C16 1.448 15.5527 1 15 1H1C0.448242 1 0 1.448 0 2V6L6 11V14.382C6 15.125 6.78223 15.608 7.44727 15.276L9.44727 14.276C9.78613 14.1071 10 13.761 10 13.382V11ZM14 5.06323V3H2V5.06323L8 10.0632L14 5.06323Z"/>
}